import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 3.9a.6.6 0 0 0-.532.323l-4.5 8.663a.6.6 0 0 0 .532.877h4.95l-1.849 7.086a.6.6 0 0 0 1.023.556l9.819-10.725a.6.6 0 0 0-.443-1.005h-4.908l3.745-4.806a.6.6 0 0 0-.473-.969z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }